import React from 'react';
import { INDEX_URL } from '@tcs/create-account/utils/routes';
import { useStyles } from './style';
import { Button } from '@forgeglobal/design-framework';

const Error404 = () => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <div className={classes.left}>
        <div className={classes.leftContent}>
          <h1 className={classes.code}>404</h1>
          <h2 className={classes.message}>That&apos;s unfortunate</h2>
        </div>
      </div>
      <div className={classes.right}>
        <div className={classes.rightContent}>
          <div className={classes.description}>
            The page you are looking for is not available
          </div>
          <Button href={INDEX_URL} size="medium" color="primary">
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Error404;
